import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Switch, Redirect, Route } from "react-router-dom";
import Auth from "../../Layout/Auth";

const NotificationPage = lazy(() => import('../Pages/NotificationPage'))

class NotificationRoute extends Component {
  render() {
    const history = createHashHistory();
    return (
      <Switch>
        <Route
          exact
          path="/:lng/notification"
          render={() => (
            <Auth history={history} allowedRoles={['app_admin']}>
              <Suspense fallback={<Loading />}>
                <NotificationPage history={history} location={location} />
              </Suspense>
            </Auth>
          )}
        />
      </Switch>
    );
  }
}
export default NotificationRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading...</span>
      </div>
    </>
  );
}
